import { createContext } from 'react'

export const IntegrationsTeamSettingsContext = createContext({})
